export const normalizePublicSiteUrl = (url) => {
  const value = String(url || '').trim();
  if (!value) return '';
  try {
    const withProtocol = /^https?:\/\//i.test(value) ? value : `https://${value}`;
    const parsed = new URL(withProtocol);
    return `${parsed.protocol}//${parsed.host}`;
  } catch (_error) {
    return '';
  }
};

export const getConfiguredPublicSiteUrl = (storefrontSettings) => {
  const fromSettings = normalizePublicSiteUrl(storefrontSettings?.publicSiteUrl);
  if (fromSettings) return fromSettings;
  const fromEnv = normalizePublicSiteUrl(process.env.REACT_APP_PUBLIC_SITE_URL);
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
};
